import { render, staticRenderFns } from "./CandidatePublicCouncilCreate.vue?vue&type=template&id=3557f75a&scoped=true&"
import script from "./CandidatePublicCouncilCreate.vue?vue&type=script&lang=js&"
export * from "./CandidatePublicCouncilCreate.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePublicCouncilCreate.vue?vue&type=style&index=0&id=3557f75a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557f75a",
  null
  
)

export default component.exports